export const SET_INTL = 'SET_INTL';

export function setIntlVariables(payload) {
    return { type: SET_INTL, intl: payload };
}
